var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("Pagination", {
    attrs: {
      resultFrom: _vm.fromPageNumber,
      resultTo: _vm.toPageNumber,
      total: _vm.config.total,
      containerClass: "shadow-none border-none",
    },
    on: { next: _vm.next, prev: _vm.prev },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }